import { render, staticRenderFns } from "./reportDesign.vue?vue&type=template&id=45b694a8&"
import script from "./reportDesign.vue?vue&type=script&lang=js&"
export * from "./reportDesign.vue?vue&type=script&lang=js&"
import style0 from "./reportDesign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports